import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { MessageWithId } from "../../store/conversationMessagesSlice";

interface ErrorMessageProps {
  message: Extract<MessageWithId, { type: "error" }>;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
      <Paper
        sx={{
          p: 2,
          maxWidth: "70%",
          bgcolor: "error.light",
          color: "text.primary",
        }}
      >
        <Box>
          <Typography color="error">{message.content.message}</Typography>
          {message.content.stack && (
            <Typography
              variant="caption"
              sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}
            >
              {message.content.stack}
            </Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );
};
